import { gql } from "@apollo/client";

export const SET_STATUS = gql`
  mutation setStatus($input: SetStatusInput!) {
    setStatus(input: $input) {
      errors
      clientMutationId
      officerIncidentSpecific {
        arrivedAtHospitalAt
        clearedAt
        currentOfficerStatus
        enrouteAt
        dispatchedAt
        fieldCheck
        enrouteToHospitalAt
        incidentId
        id
        logCodeId
        logCode {
          id
          name
        }
        lastContactedAt
        onSceneAt
        officer {
          id
          deptAttribute {
            assignment
            badge
            carNumber
            id
            lastContactedAt
            notes
            ori {
              id
              abbreviation
              oriName
              municipalityNumber
            }
            radioNumber
            secondaryAddress
            skillsList
            status
          }
        }
        secondaryAddress
        primaryOfficer
        statusId
      }
      officer {
        id
        deptAttribute {
          assignment
          badge
          carNumber
          id
          lastContactedAt
          notes
          ori {
            id
            abbreviation
            oriName
            municipalityNumber
          }
          radioNumber
          secondaryAddress
          skillsList
          status
        }
      }
    }
  }
`;
